
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purchases",
      function () {
        return require("private-next-pages/purchases/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/purchases"])
      });
    }
  